import { CharacterCount } from '.';
import type { CharacterCountOptions, CharacterCountStorage } from '@tiptap/extensions';

interface CustomCharacterCountOptions extends CharacterCountOptions {
   minCharacters: number;
}

export interface CustomCharacterCountStorage extends CharacterCountStorage {
   minCharacters: number;
   maxCharacters: number;
}

export interface CharacterCountConfig {
   minCharacters?: number;
   maxCharacters?: number;
}

export const CustomCharacterCount = CharacterCount.extend<
   CustomCharacterCountOptions,
   CustomCharacterCountStorage
>({
   addOptions() {
      return {
         ...this.parent?.(),
         minCharacters: 0,
         autoTrim: false,
      } as CustomCharacterCountOptions;
   },
   addStorage() {
      return {
         ...this.parent?.(),
         minCharacters: this.options.minCharacters,
         maxCharacters: this.options.limit as number,
      } as CustomCharacterCountStorage;
   },
});
